// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';
import { SPOT_GREY_7 } from '@thredup/styleguide/src/variables/colors';

const Bar: React.FC<BarItemProps> = (props) => {
  const { data, color, height, label, width, x, y } = props;
  const { indexValue } = data;

  const labelProps = {
    className: 'text-sm',
    dominantBaseline: 'central',
    textAnchor: 'start',
    style: {
      fill: SPOT_GREY_7
    }
  };

  return (
    <g transform={`translate(${x}, ${y})`}>
      <text {...labelProps} x={0} y={-10}>
        {indexValue}
      </text>
      <rect
        fill={color}
        height={height}
        stroke="white"
        strokeWidth="0"
        width={width}
      />

      <text {...labelProps} x={570} y={10}>
        {`${label} lbs`}
      </text>
    </g>
  );
};

export { Bar };
